import React, {FC} from "react";
import {Box} from "zmp-ui";

export const Divider = ({
                           size = 8,
                           ...props
                        }) => {
   return (
      <Box
         style={{
            minHeight: size,
            backgroundColor: "#E3F1F0",
            opacity: 0.3
         }}
         {...props}
      />
   );
};
